
import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();

  const quickLinks = [
    { name: 'Home', href: '/', scrollTo: 'hero' },
    { name: 'About', href: '/', scrollTo: 'about' },
    { name: 'Services', href: '/', scrollTo: 'services' },
    { name: 'Products', href: '/', scrollTo: 'products' },
    { name: 'Contact', href: '/contact' },
    { name: 'Blog', href: '/blog' },
  ];

  const services = [
    'Product Sourcing',
    'Supply Chain Management',
    'Product Development',
    'Quality Control',
    'Logistics Solutions',
  ];

  const handleNavClick = (item: any) => {
    if (item.scrollTo) {
      if (location.pathname !== '/') {
        window.location.href = `/#${item.scrollTo}`;
      } else {
        const element = document.getElementById(item.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <span className="text-2xl font-bold text-teal-400">
                XJ GLOBAL
              </span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Leading sourcing, product development and supply chain management company for the world's largest retail chain stores and brands.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  {link.scrollTo ? (
                    <button
                      onClick={() => handleNavClick(link)}
                      className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </button>
                  ) : (
                    <Link 
                      to={link.href} 
                      className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service} className="text-gray-300">
                  {service}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 XJ Global. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
